export enum SessionStorageKey {
  PROMO_CODE = 'promoCode',
  DEFERRED_URL = 'deferredUrl',
  DID_USER_LOGOUT = 'hasLoggedOut',
  REF_ID = 'refId',
  VOUCHER_SHORT_CODE = 'voucherShortCode',
  CASEME_NEWSLETTER_TRIGGERED = 'caseme_newsletter_triggered',
  CASEME_NEWSLETTER_AWAITING = 'caseme_newsletter_awaiting',
  MARKETING_MODAL_ANONYMOUS_ID = 'marketing_modal_session_id', // Renamed to session_id but keeping the enum name for backward compatibility
  LAST_SEARCH_CLICKED_ID = 'lastSearchClickedId',
  /** Skip auto-opening the FTU modal for this tab session (e.g. deep link checkout). */
  DEFER_ONBOARDING_MODAL = 'deferOnboardingModal',
  /** Prompt IDs already shown or handled this browser session. */
  EDUCATION_PROGRESSION_HANDLED_PROMPT_IDS = 'educationProgressionHandledPromptIds',
}

export const useSessionStorage = <T>(
  key: SessionStorageKey,
  initialValue?: T
): {
  getValue: () => T | undefined;
  setValue: (value: T) => void;
  deleteItem: () => void;
} => {
  const getValue = (): T | undefined => {
    if (typeof window === 'undefined') return initialValue;

    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  };

  const setValue = (value: T): void => {
    if (typeof window === 'undefined') return;

    sessionStorage.setItem(key, JSON.stringify(value));
  };

  const deleteItem = (): void => {
    if (typeof window === 'undefined') return;

    sessionStorage.removeItem(key);
  };

  return { getValue, setValue, deleteItem };
};
